import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { calculateCarbonEmissions } from '../../utils/carbonEmissionsUtils';
import { translate as t } from '../../lib/I18n';
import OnEnterTrigger from '../general/OnEnterTrigger';
import CarbonFootprintModal from './CarbonFootprintModal';
import GreenPlanetIcon from '../icons/GreenPlanetIcon';
import Icon from '../general/Icon';
import OrderFare from '../../records/order/Fare';
import Trip from '../../records/Trip';

const CarbonFootprintButton = ({ className, fare }) => {
    const [isOpen, setModalStatus] = useState(false);
    const toggleModal = (value) => () => setModalStatus(value);

    const { origin: originStation, destination: destinationStation } = fare;

    const carbonCalculationData = calculateCarbonEmissions({ fare, originStation, destinationStation });
    const { savedCO2e } = carbonCalculationData;

    return (
        <Fragment>
            <div className={className}>
                <OnEnterTrigger onClick={toggleModal(true)} className='carbon-footprint__button'>
                    <div>
                        <div className='carbon-footprint__button--title-container'>
                            <div className='carbon-footprint__button--icon'>
                                <GreenPlanetIcon />
                            </div>
                            <p className='carbon-footprint__button--text'>
                                <strong>
                                    { t('carbonFootprint.saved', { savedCO2e }) }
                                </strong>
                            </p>
                        </div>
                        <div className='carbon-footprint__button--info-container'>
                            <p className='carbon-footprint__button--text'>
                                { t('carbonFootprint.button.info') }
                            </p>
                            <Icon icon="chevronslim" className="carbon-footprint__button--chevron-icon" />
                        </div>
                    </div>
                </OnEnterTrigger>
            </div>
            <CarbonFootprintModal
                toggleModal={toggleModal}
                show={isOpen}
                carbonCalculationData={carbonCalculationData}
            />
        </Fragment>
    );
};

CarbonFootprintButton.propTypes = {
    className: PropTypes.string,
    fare: PropTypes.instanceOf(OrderFare).isRequired,
    trip: PropTypes.instanceOf(Trip)
};

CarbonFootprintButton.defaultProps = {
    className: '',
};

export default CarbonFootprintButton;
